<!-- Copyright (C) Siemens AG 2026. All rights reserved. -->
<!--The content below is only a placeholder and can be replaced.-->
<!-- <div class="h-100">
  <app-main-page></app-main-page>
</div> -->

<router-outlet></router-outlet>
